module.exports = __webpack_public_path__ + "static/media/chestplate-common.cf8222f8.png";